<ion-content>
  <div class="ticker-container">
    <div class="ticker" id="ticker-top">
      <ng-container *ngFor="let welcome of welcomes">
        <span [ngClass]="'lang-' + welcome.lang">{{ welcome.text }}</span>
      </ng-container>
      <ng-container *ngFor="let welcome of welcomes">
        <span [ngClass]="'lang-' + welcome.lang">{{ welcome.text }}</span>
      </ng-container>
    </div>
  </div>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <img src="assets/images/logo.png" alt="Gnok News Logo" class="welcome-logo">
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <h1 *ngIf="user && targetLang" class="welcome-header">{{ 'WELCOME.WELCOME' | translate }}</h1>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-button expand="full" (click)="goToExampleArticle()">
          {{ 'WELCOME.START_TOUR' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="ticker-container ticker-bottom">
    <div class="ticker-reverse" id="ticker-bottom">
      <ng-container *ngFor="let welcome of welcomes">
        <span [ngClass]="'lang-' + welcome.lang">{{ welcome.text }}</span>
      </ng-container>
      <ng-container *ngFor="let welcome of welcomes">
        <span [ngClass]="'lang-' + welcome.lang">{{ welcome.text }}</span>
      </ng-container>
    </div>
  </div>
</ion-content>